import { apiClient } from "@/services/apiClient";

/**
 * A profession slug.
 *
 * Open, not a two-value union. It was `"notary" | "accountant"` until traductor
 * público was registered, at which point the literal described the platform's
 * professions wrongly while still compiling — these values arrive from the
 * server, so the type was never checked against one.
 */
export type QuoteFeeDiscipline = string;

export interface QuoteFeeRateRow {
  discipline: QuoteFeeDiscipline;
  /** The registry's name for the discipline. Null if the profession is gone. */
  displayName: string | null;
  /** Added to what the consumer pays, as a percentage of the leg's honorarios. */
  consumerFeePercent: number;
  /** Withheld from the professional. 0 wherever commissionPermitted is false. */
  professionalCommissionPercent: number;
  /**
   * Whether this profession may be charged a commission at all, from its
   * registry row. The screen disables the input on false rather than deciding
   * for itself which professions are protected.
   */
  commissionPermitted: boolean;
  updatedAt: string;
}

export function listQuoteFeeRates(): Promise<QuoteFeeRateRow[]> {
  return apiClient
    .get<QuoteFeeRateRow[]>("/platform/quote-fee-rates")
    .then((res) => res.data);
}

export function updateQuoteFeeRate(payload: {
  discipline: QuoteFeeDiscipline;
  consumerFeePercent: number;
  professionalCommissionPercent: number;
}): Promise<QuoteFeeRateRow> {
  return apiClient
    .put<QuoteFeeRateRow>("/platform/quote-fee-rates", payload)
    .then((res) => res.data);
}
